import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { inviteProvider as inviteProviderApi } from '../../util/api';

// ================ Async thunks ================ //

export const inviteProviderThunk = createAsyncThunk(
  'InviteProviderPage/inviteProvider',
  (params, { rejectWithValue }) => {
    return inviteProviderApi(params).catch(e => {
      return rejectWithValue(storableError(e));
    });
  }
);

// Backward compatible wrapper for the inviteProvider thunk
export const inviteProvider = params => dispatch => {
  return dispatch(inviteProviderThunk(params)).unwrap();
};

// ================ Slice ================ //

const inviteProviderSlice = createSlice({
  name: 'InviteProviderPage',
  initialState: {
    inviteInProgress: false,
    inviteError: null,
    inviteSuccess: false,
    inviteLink: null,
  },
  reducers: {
    inviteProviderClear: state => {
      state.inviteInProgress = false;
      state.inviteError = null;
      state.inviteSuccess = false;
      state.inviteLink = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(inviteProviderThunk.pending, state => {
        state.inviteInProgress = true;
        state.inviteError = null;
        state.inviteSuccess = false;
        state.inviteLink = null;
      })
      .addCase(inviteProviderThunk.fulfilled, (state, action) => {
        state.inviteInProgress = false;
        state.inviteSuccess = true;
        state.inviteLink = action.payload?.inviteLink || null;
      })
      .addCase(inviteProviderThunk.rejected, (state, action) => {
        console.error(action.payload); // eslint-disable-line no-console
        state.inviteInProgress = false;
        state.inviteError = action.payload;
      });
  },
});

export const { inviteProviderClear } = inviteProviderSlice.actions;

export default inviteProviderSlice.reducer;
